import store from '@/store'
import {getProfileViewCounter} from "@/api/profile_view_counter";
import {
    GTM_BUY_CREDITS_TESTS_TRIGGER1_B_CREDITS_PAGE_VIEW,
    GTM_BUY_CREDITS_TESTS_TRIGGER1_B_PURCHASED_CREDITS
} from "@/service/gtm/types";
import {paymentFlowSource} from "@/service/payment/PaymentFlowSource";
import {pushDataLayer} from "@/service/gtm";
import {
    GTM_BUY_CREDITS_TESTS_TRIGGER1_A_CREDITS_PAGE_VIEW,
    GTM_BUY_CREDITS_TESTS_TRIGGER1_A_PURCHASED_CREDITS
} from "@/service/gtm/types";
import Router from "@/router";

export async function userRouteAccess(to, from, next) {
    const user = store.state.authenticate.auth.user
    const balance = store.state.credits.amount

    if (!user.a_b_group){
        return next()
    }
    if (balance > 0){
        return next()
    }

    function handleGroupAction() {
        if (user.a_b_group === 'a') {
            pushDataLayer(GTM_BUY_CREDITS_TESTS_TRIGGER1_A_CREDITS_PAGE_VIEW, store.state.authenticate.auth.user.id)
            paymentFlowSource.setItem(GTM_BUY_CREDITS_TESTS_TRIGGER1_A_PURCHASED_CREDITS)
            return next({ name: 'credits' })
        } else {
            pushDataLayer(GTM_BUY_CREDITS_TESTS_TRIGGER1_B_CREDITS_PAGE_VIEW, store.state.authenticate.auth.user.id)
            store.dispatch('buyCreditPopup/open', {
                headline: 'buy_credits_popup.trigger1.headline',
                body: 'buy_credits_popup.trigger1.body',
                buttonText: 'buy_credits_popup.trigger1.buttonText',
                props: { gtm_purchase: GTM_BUY_CREDITS_TESTS_TRIGGER1_B_PURCHASED_CREDITS},
                dismissible: true
            })

            if (from.name === undefined){
                Router.push({name: 'search'})
            }else{
                return next(false)
            }

        }
    }

    //to skip unnecessary backend calling
    let timeElapsed = localStorage.getItem('pvc')
    if (timeElapsed){
        const timestamp = Math.floor(Date.now() / 1000);

        if (timestamp < timeElapsed){
            return handleGroupAction()
        }
    }

    const payload = await getProfileViewCounter()

    if (payload.data.allowed){
        localStorage.removeItem('pvc')
        return next()
    }else {
        localStorage.setItem('pvc', payload.data.windowEnding)
        return handleGroupAction()
    }
}